import React, { useState, useEffect } from 'react'
import ThumbsUp from '../../assets/images/thumbsUp.svg'
import ThumbsUpSelected from '../../assets/images/thumbsUpSelected.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import commentAxios from 'api/commentsAxios'
import { class_series_like_and_dislike_events } from 'gtm/pushEvents'

const Container = styled(Flex)`
  gap: 12px;
  align-items: center;
  justify-content: center;
  .thumbs-down {
    transform: rotate(180deg);
  }
`
const LikeButtonWrapper = styled(Flex)`
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
`
const LikeCount = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova',
  fontWeight: 400,
  lineHeight: '18px' /* 128.571% */,
  letterSpacing: '0.308px',
  visibility: (props) => (props.isVisible ? 'visible' : 'hidden')
})

const LikesAndDislikes = ({
  type,
  classDetails,
  coaches,
  videoDetails,
  seriesDetails
}) => {
  const [likes, setLikes] = useState(0)
  const [userLiked, setUserLiked] = useState(null)
  const [userDisLiked, setUserDisLiked] = useState(null)
  const [load, setLoad] = useState(false)

  useEffect(() => {
    fetchContentInfo()
  }, [])

  const fetchContentInfo = async () => {
    try {
      const response = await commentAxios.post('/content-info', {
        content_type: type,
        content_id: classDetails?.id
      })
      if (response.status === 200) {
        setUserLiked(response?.data?.likedByMe)
        setLikes(response?.data?.likes)
        setUserDisLiked(response?.data?.dislikedByMe)
      }
    } catch (err) {
      console.log(err)
    }
  }
  const onLikeOrDislike = async (reactionType) => {
    const prev = { userLiked, userDisLiked, likes }
    try {
      reactionType == 'LIKE' &&
        setLikes((state) => (userLiked ? state - 1 : state + 1))
      setLoad(true)
      const response = await commentAxios.post(
        '/content-interaction/reaction',
        {
          content_type: type,
          content_id: classDetails?.id,
          type: reactionType,
          title: classDetails?.title,
          instructors: coaches?.map((coach) => ({
            ...coach,
            full_name: coach?.fullName
          }))
        }
      )
      if (response.status === 200) {
        setUserLiked(response?.data?.likedByMe)
        setLikes(response?.data?.likes)
        setUserDisLiked(response?.data?.dislikedByMe)
      }
    } catch (err) {
      console.log(err)
      setUserLiked(prev.userLiked)
      setUserDisLiked(prev.userDisLiked)
      setLikes(prev.likes)
    } finally {
      setLoad(false)
    }
  }

  const ga4LikeandDislikeEvent = (likeDislikeType) => {
    if (type === 'CLASS') {
      class_series_like_and_dislike_events(
        type.toLowerCase(),
        likeDislikeType,
        seriesDetails?.title,
        coaches?.map((coach) => coach?.fullName).join(', '),
        classDetails?.title,
        videoDetails?.title
      )
    } else if (type === 'SERIES') {
      class_series_like_and_dislike_events(
        type.toLowerCase(),
        likeDislikeType,
        classDetails?.title,
        coaches?.map((coach) => coach?.fullName).join(', ')
      )
    }
  }

  const likeClickHandler = () => {
    if (load) return
    setUserLiked((prev) => !prev)
    setUserDisLiked(false)
    onLikeOrDislike('LIKE')
    ga4LikeandDislikeEvent('up')
  }

  const dislikeClickHandler = () => {
    if (load) return
    setUserDisLiked((prev) => !prev)
    setUserLiked(false)

    onLikeOrDislike('DISLIKE')
    ga4LikeandDislikeEvent('down')
  }

  return (
    <>
      <Container>
        <LikeButtonWrapper>
          <ResponsiveSVG
            SVG={userLiked ? ThumbsUpSelected : ThumbsUp}
            style={{
              cursor: 'pointer'
            }}
            width='24px'
            height='24px'
            onClick={() => likeClickHandler()}
          />
          <LikeCount isVisible={likes > 0}>{likes}</LikeCount>
        </LikeButtonWrapper>

        <LikeButtonWrapper>
          <ResponsiveSVG
            SVG={userDisLiked ? ThumbsUpSelected : ThumbsUp}
            style={{
              cursor: 'pointer'
            }}
            width='24px'
            height='24px'
            className='thumbs-down'
            onClick={() => dislikeClickHandler()}
          />
          <LikeCount>
            <span>&nbsp;&nbsp;</span>
          </LikeCount>
        </LikeButtonWrapper>
      </Container>
    </>
  )
}

export default LikesAndDislikes
